import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CmsService, HOME_PAGE_CONTEXT, Occ, PageContext } from '@spartacus/core';
import { BehaviorSubject, Observable, Subscription, combineLatest } from 'rxjs';
import PageType = Occ.PageType;

@Injectable({
  providedIn: 'root',
})
export class SiteService implements OnDestroy {
  private subscriptions: Subscription = new Subscription();
  private currentSiteName: string;
  private _currentSite;
  currentSite: Observable<string>;
  private readonly homePageContext: PageContext = { id: HOME_PAGE_CONTEXT, type: PageType.CONTENT_PAGE };

  constructor(private router: Router,
    private cmsService: CmsService) {

    this.currentSiteName = '';

    this.getDefaultPage();

    this._currentSite = new BehaviorSubject<string>(this.currentSiteName);
    this.currentSite = this._currentSite.asObservable();

    this.subscriptions.add(
      combineLatest([
        this.cmsService.getCurrentPage(),
        this.router.events
      ]).subscribe(([currentPage, routerEvent]) => {
        if (routerEvent instanceof NavigationEnd) {
          switch (currentPage?.pageId) {
            case 'homepage':
              this.changeCurrentSite('ohgar');
              break;
            case 'homepageOhbar':
              this.changeCurrentSite('ohbar');
              break;
            case 'homepageOutlet':
              this.changeCurrentSite('outlet');
              break;
          }
        }
      })
    );
  }

  getDefaultPage(): void {
    const pathName = window.location.pathname;

    if (pathName.indexOf('ohgar') >= 0) {
      this.currentSiteName = 'ohgar';
    } else if (pathName.indexOf('ohbar') >= 0) {
      this.currentSiteName = 'ohbar';
    } else if (pathName.indexOf('outlet') >= 0) {
      this.currentSiteName = 'outlet';
    }

    if (!this.currentSiteName) {
      this.subscriptions.add(this.cmsService.getPage(this.homePageContext, true).subscribe(homepage => {
        switch (homepage?.pageId) {
          case 'homepage':
            this.changeCurrentSite('ohgar');
            break;
          case 'homepageOhbar':
            this.changeCurrentSite('ohbar');
            break;
          case 'homepageOutlet':
            this.changeCurrentSite('outlet');
            break;
        }
      }));
    }
  }

  private changeCurrentSite(site: string): void {
    if (this.currentSiteName !== site) {
      this.currentSiteName = site;
      this._currentSite?.next(site);
    }
  }

  ngOnDestroy(): void {
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
